<div class="offcanvas-content pr-5 mr-n5">
    <div class="d-flex justify-content-between align-items-center mb-5">
        <div class="d-flex">
            <div class="panel-nav_icon d-inline-flex">
                <button class="btn"
                        (click)="openFormPanel()">
                    <i class="fa fa-arrow-left"></i>
                </button>
            </div>
            <div class="panel-nav_title d-inline-flex align-self-center">
                {{l('SelectaForm')}}
            </div>
        </div>

        <div class="d-flex">
            <button class="btn btn-default"
                    (click)="closePanel()">
                {{ l('Cancel') }}
            </button>

            <button class="btn btn-primary"
                    (click)="saveNewActivity()"
                    [disabled]="!activityName || !daysSelected.length">
                {{ l('Create') }}
            </button>
        </div>
    </div>

    <div class="navi navi-spacer-x-0 p-0">
        <div class="col-md-12">
            <div class="form-group">
                <label class="bold"
                       for="activityName">{{l("ActivityName")}}</label>
                <input type="text"
                       class="form-control"
                       id="activityName"
                       [placeholder]="l('ActivityNamePlaceholder')"
                       [(ngModel)]="activityName">
            </div>
        </div>

        <div class="col-md-12 mat-calendar-style">
            <mat-label class="bold" [matTooltip]="l('PickDatesBelow')">{{ l('SelectTheDaysToCreateTheActivityFor') }}</mat-label>
            <mat-calendar #calendar
                          (selectedChange)="select($event,calendar)"
                          [dateClass]="isSelected"></mat-calendar>
        </div>
    </div>
</div>
